<div [formGroup]="formGroup">
  <kendo-grid
    #grid="kendoGrid"
    id="invVoucherGrid"
    [data]="gridData"
    [reorderable]="true"
    [resizable]="true"
    [pageSize]="state.take"
    (filterChange)="filterChanges($event)"
    [filter]="state.filter"
    [filterable]="true"
    [skip]="state.skip"
    [pageable]="false"
    [sort]="state.sort"
    [sortable]="{ allowUnsort: true, mode: 'multiple' }"
    [columnMenu]="true"
    [kendoGridSelectBy]="'RowNumber'"
    [selectedKeys]="mySelection"
    (remove)="removeHandler($event)"
    (save)="saveCurrent()"
    (edit)="editHandler($event)"
    (sortChange)="sortChange($event)"
    (cellClick)="onCellClick($event)"
    (cellClose)="saveCell($event)"
    [rowSelected]="isRowSelected"
    [selectable]="true"
    [style.height.vh]="gridHeight ?? 35"
    [navigable]="true">
    <ng-template kendoGridToolbarTemplate>
      <ssg-button
        [disabled]="rowIsEditing || !isAdd"
        (click)="addHandler()"
        tooltip="ایجاد رکورد جدید(alt+shift+N)"
        icon="icon-NewRecord"
        class="btnstyle">
      </ssg-button>
      <ssg-button
        [disabled]="!rowIsEditing"
        (click)="cancelHandler()"
        tooltip="لغو تغییرات(Escape)"
        icon="icon-forbidden-2"
        class="btnstyle"></ssg-button>
      <ssg-button
        [disabled]="!mySelection || mySelection.length <= 0"
        (click)="copyHandler()"
        tooltip="کپی به حافظه(ctrl+C)"
        icon="icon-copyRow"
        class="btnstyle">
      </ssg-button>
      <ssg-button
        [disabled]="!hasdatForPaset()"
        (click)="pasetHandler()"
        tooltip="کپی از حافظه(ctrl+V)"
        icon="icon-Paste"
        class="btnstyle"></ssg-button>
      <ssg-button (click)="copyAll()" tooltip="کپی کل سند" icon="icon-copyAll" class="btnstyle"></ssg-button>
      <ssg-button
        *ngIf="HasJournalVoucher === true"
        type="button"
        class="btnstyle"
        icon="icon-edit-o"
        [disabled]="AccountRegistered || rowIsEditing"
        (click)="editSubledgerDetailLedger()"
        tooltip="اصلاح معین و تفصیلی">
      </ssg-button>
      <ssg-button type="button" class="btnstyle" icon="icon-settings-o1" (click)="setDefaultColumnInfo()" data-tooltip="top" tooltip="تنظیمات پیشفرض">
      </ssg-button>
    </ng-template>

    <kendo-grid-command-column width="75" minResizableWidth="70" *ngIf="isDelete || isEdit" title="عملیات" [columnMenu]="false">
      <ng-template kendoGridCellTemplate>
        <button kendoGridEditCommand [primary]="true" icon="edit" title="ویرایش"></button>
        <button *ngIf="isEdit" kendoGridSaveCommand [disabled]="formGroup?.invalid" icon="save" title="{{ isNew ? 'جدید' : 'تغییر' }}"></button>
        <button *ngIf="isDelete" kendoGridRemoveCommand icon="delete" title="حذف"></button>
      </ng-template>
    </kendo-grid-command-column>

    <kendo-grid-column
      *ngFor="let column of columns; let i = index"
      field="{{ column.name }}"
      title="{{ column.label }}"
      format="{{ column.format }}"
      [width]="column.columnWidth"
      [hidden]="!column.listVisible"
      [minResizableWidth]="column.columnWidth"
      [editable]="!column.disabled"
      editor="{{ column.textType == 'checkbox' ? 'boolean' : column.textType == 'number' ? 'numeric' : column.textType == 'date' ? 'date' : 'text' }}"
      filter="{{
        column.textType == 'checkbox' ? 'boolean' : column.textType == 'number' ? 'numeric' : column.textType == 'date' ? 'date' : 'text'
      }}">
      <ng-template *ngIf="column.apiName" kendoGridCellTemplate let-dataItem>
        {{
          getItemDisplayById(
            column.apiName,
            column.systemName,
            dataItem[column.name],
            column.displayMember,
            column.valueMember,
            dataItem,
            column.name
          )
        }}
      </ng-template>
      <ng-template *ngIf="column.textType === 'date'" kendoGridCellTemplate let-dataItem>
        {{ getDateValue(dataItem[column.name]) }}
      </ng-template>
      <ng-template
        *ngIf="column.apiName && !hasMultiColumns(column.columnsName)"
        kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup"
        let-isNew="isNew">
        <kendo-dropdownlist
          #ddl="popupAnchor"
          popupAnchor
          [defaultItem]="{ Id: null, Title: 'تهی کردن اطلاعات' }"
          [data]="LookupData[column.apiName]"
          textField="{{ column.displayMember }}"
          valueField="{{ column.valueMember }}"
          (selectionChange)="selectionChange($event, column.apiName, column.name)"
          [valuePrimitive]="true"
          [formControl]="formGroup.get(column.name)">
        </kendo-dropdownlist>
        <kendo-popup
          [anchor]="ddl.element"
          *ngIf="formGroup.get(column.name).invalid && !(isNew && formGroup.get(column.name).untouched)"
          popupClass="k-widget k-tooltip k-tooltip-validation k-invalid-msg">
          <span class="k-icon k-i-warning"></span>
          {{ column.label }} الزامی است
        </kendo-popup>
      </ng-template>
      <ng-template
        *ngIf="column.apiName && hasMultiColumns(column.columnsName)"
        kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup"
        let-isNew="isNew">
        <st-lookup
          name="{{ column.name }}"
          [group]="formGroup"
          [dataList]="LookupData[column.apiName]"
          [apiName]="column.name === 'ReferenceId' ? undefined : column.apiName"
          textFieldName="{{ column.displayMember }}"
          valueFieldName="{{ column.valueMember }}"
          [isMulti]="true"
          [defaultHeight]="30"
          [isPaging]="true"
          [filtering]="column.name === 'ReferenceId'"
          [groupsName]="column.name === 'ReferenceId' ? groupsName : undefined"
          [onDataStateChange]="column.name === 'GoodsCode' || column.name === 'GoodsId' ? onDataStateChange : undefined"
          textColumnsName="{{ column.columnsName }}"
          [pageHeight]="column.name === 'ReferenceId' ? 1.5 : undefined"
          (onRowSelected)="selectionChange($event, column.apiName, column.name)"
          (onRowsSelected)="onRowsSelected($event, column.apiName, column.name)"
          [disabled]="false">
        </st-lookup>
      </ng-template>
      <ng-template *ngIf="column.textType === 'date'" kendoGridEditTemplate let-dataItem>
        <date-picker
          id="dp{{ column.name }}"
          [defaultHeight]="30"
          [group]="formGroup"
          name="{{ column.name }}"
          label="{{ column.label }}"
          textType="{{ column.textType }}">
        </date-picker>
      </ng-template>
      <ng-template *ngIf="column.name == 'GoodsTitle'" kendoGridFooterTemplate> جمع </ng-template>
      <ng-template *ngIf="hasAggregate(column.name)" kendoGridFooterTemplate> {{ getColumnAggregates(column.name) | number }} </ng-template>
      <ng-template *ngIf="column.textType == 'checkbox'" kendoGridCellTemplate let-dataItem>
        <input type="checkbox" class="k-checkbox" [(checked)]="dataItem[column.name]" />
      </ng-template>
      <ng-template *ngIf="column.textType !== 'date' && !column.apiName" kendoGridGroupHeaderTemplate let-value="value">
        {{ value }}
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
